import { Box, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';
import { t } from '../utils/translationUtils';
import translations from '../translations';

function Footer() {
    const { language } = useLanguage();


    return (
        <Box
            sx={{
                maxWidth: '1890px',
                margin: '0 auto',
                position: 'relative',
                width: '100%',
                height: '100%',
                fontSize: { xs: '0.7rem', sm: '0.9rem', md: '1rem' },
                fontWeight: 400,
                textAlign: 'center',
            }}
        >


            <Box
                component="footer"
                sx={{
                    position: 'relative',
                    backgroundSize: {
                        xs: '100%',
                        sm: 'contain',
                        md: 'contain',
                    },
                    backgroundPosition: 'center bottom',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: '#000000',
                    py: { xs: 32, sm: 25, md: 36 },
                    color: '#FFFFFF',
                    width: '100%',
                    textAlign: 'center',
                    overflow: 'hidden',
                    maxHeight: { xs: 'none', sm: 'none', md: '300px' },
                    '& .footer-text': {
                        fontFamily: 'Poppins',
                        fontSize: { xs: '1rem', sm: '1.25rem', md: '1.25rem', lg: '24px' },
                        fontWeight: 400,
                        textAlign: 'left',
                    },
                    '& .footer-title': {
                        fontFamily: 'Poppins',
                        fontSize: { xs: '1rem', sm: '1.25rem', md: '1.25rem', lg: '24px' },
                        fontWeight: 'bold',
                        mb: 2,
                        textAlign: 'left',
                    }
                }}
            >
                <Grid
                    container
                    spacing={4}
                    justifyContent="space-between"
                    alignItems="flex-start"
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        pt: { xs: 2, sm: 4, md: 6 },
                        pl: { xs: 10, sm: 13, md: 16, lg: 20 },
                        pr: { xs: 2, sm: 4, md: 6 },
                    }}
                >
                    <Grid item xs={6} sm={3} display="flex" flexDirection="column" alignItems="flex-start">
                        <Typography className="footer-title">
                            {t("FooterBox1", translations, language)}
                        </Typography>
                        <Link className="footer-text" to="/personal" style={{
                            textDecoration: 'none',
                            color: 'inherit',
                            marginBottom: 1,
                            alignSelf: 'flex-start',
                            display: 'block'
                        }}>
                            {t("FooterBox2", translations, language)}
                        </Link>
                        <Link className="footer-text" to="/business" style={{
                            textDecoration: 'none',
                            color: 'inherit',
                            marginBottom: 1,
                            alignSelf: 'flex-start',
                            display: 'block'
                        }}>
                            {t("FooterBox3", translations, language)}
                        </Link>
                        <Link className="footer-text" to="/contact_us" style={{
                            textDecoration: 'none',
                            color: 'inherit',
                            marginBottom: 1,
                            alignSelf: 'flex-start',
                            display: 'block'
                        }}>
                            {t("Contatti", translations, language)}
                        </Link>
                    </Grid>
                    <Grid item xs={6} sm={3} display="flex" flexDirection="column" alignItems="flex-start">
                        <Typography className="footer-title">
                            {t("FooterBox4", translations, language)}
                        </Typography>
                        {language === 'it' ? (
                            <Box onClick={() => window.open('https://help.crhmoney.com/it/articles/10252040-privacy-policy-crh-money-italiano', '_blank')}
                                style={{ cursor: 'pointer', marginBottom: 1, alignSelf: 'flex-start' }}>
                                <Typography className="footer-text">
                                    Privacy
                                </Typography>
                            </Box>
                        ) : (
                            <Box onClick={() => window.open('https://help.crhmoney.com/it/articles/10252047-privacy-policy-crh-money-english', '_blank')}
                                style={{ cursor: 'pointer', marginBottom: 1, alignSelf: 'flex-start' }}>
                                <Typography className="footer-text">
                                    Privacy
                                </Typography>
                            </Box>
                        )}
                        {language === 'it' ? (
                            <Box onClick={() => window.open('https://help.crhmoney.com/it/articles/10252038-crh-money-cookie-policy-italiano', '_blank')}
                                style={{ cursor: 'pointer', marginBottom: 1, alignSelf: 'flex-start' }}>
                                <Typography className="footer-text">
                                    Cookie
                                </Typography>
                            </Box>
                        ) : (
                            <Box onClick={() => window.open('https://help.crhmoney.com/it/articles/10252051-cookies-policy-crh-money-english', '_blank')}
                                style={{ cursor: 'pointer', marginBottom: 1, alignSelf: 'flex-start' }}>
                                <Typography className="footer-text">
                                    Cookie
                                </Typography>
                            </Box>
                        )}
                        {language === 'it' ? (
                            <Box onClick={() => window.open('https://help.crhmoney.com/it/articles/10252142-termini-e-condizioni-crh-money-italiano', '_blank')}
                                style={{ cursor: 'pointer', marginBottom: 1, alignSelf: 'flex-start' }}>
                                <Typography className="footer-text">
                                    T&C conto personale
                                </Typography>
                            </Box>
                        ) : (
                            <Box onClick={() => window.open('https://help.crhmoney.com/it/articles/10252139-crh-money-term-and-conditions-english', '_blank')}
                                style={{ cursor: 'pointer', marginBottom: 1, alignSelf: 'flex-start' }}>
                                <Typography className="footer-text">
                                    T&C account personal
                                </Typography>
                            </Box>
                        )}
                        {language === 'it' ? (
                            <Box onClick={() => window.open(process.env.PUBLIC_URL + '/docs/T&C_it.pdf', '_blank')}
                                style={{ cursor: 'pointer', marginBottom: 1, alignSelf: 'flex-start' }}>
                                <Typography className="footer-text">
                                    T&C conto business
                                </Typography>
                            </Box>
                        ) : (
                            <Box onClick={() => window.open(process.env.PUBLIC_URL + '/docs/T&C_en.pdf', '_blank')}
                                style={{ cursor: 'pointer', marginBottom: 1, alignSelf: 'flex-start' }}>
                                <Typography className="footer-text">
                                    T&C account business
                                </Typography>
                            </Box>
                        )}
                        {language === 'it' ? (
                            <Box onClick={() => window.open(process.env.PUBLIC_URL + '/docs/T&C_visa_it.pdf', '_blank')}
                                style={{ cursor: 'pointer', marginBottom: 1, alignSelf: 'flex-start' }}>
                                <Typography className="footer-text">
                                    T&C Corporate Business Visa
                                </Typography>
                            </Box>
                        ) : (
                            <Box onClick={() => window.open(process.env.PUBLIC_URL + '/docs/T&C_visa_en.pdf', '_blank')}
                                style={{ cursor: 'pointer', marginBottom: 1, alignSelf: 'flex-start' }}>
                                <Typography className="footer-text">
                                    T&C Corporate Business Visa
                                </Typography>
                            </Box>
                        )}
                    </Grid>
                    <Grid item xs={6} sm={3} display="flex" flexDirection="column" alignItems="flex-start">
                        <Typography className="footer-title">
                            {t("FooterBox16", translations, language)}
                        </Typography>
                        <Link className="footer-text" to="/news" style={{
                            textDecoration: 'none',
                            color: 'inherit',
                            marginBottom: 1,
                            alignSelf: 'flex-start',
                            display: 'block'
                        }}>
                            {t("FooterBox17", translations, language)}
                        </Link>
                        <Link className="footer-text" to="/news" style={{
                            textDecoration: 'none',
                            color: 'inherit',
                            alignSelf: 'flex-start',
                            display: 'block'
                        }}>
                            {t("FooterBox17b", translations, language)}
                        </Link>
                    </Grid>
                    <Grid item xs={6} sm={3} display="flex" flexDirection="column" alignItems="flex-start">
                        <Typography className="footer-title">
                            {t("FooterBox18", translations, language)}
                        </Typography>
                        <Link className="footer-text" to="/personal" style={{
                            textDecoration: 'none',
                            color: 'inherit',
                            marginBottom: 1,
                            alignSelf: 'flex-start',
                            display: 'block'
                        }}>
                            {t("FooterBox19", translations, language)}
                        </Link>
                        <Link className="footer-text" to="/business" style={{
                            textDecoration: 'none',
                            color: 'inherit',
                            marginBottom: 1,
                            alignSelf: 'flex-start',
                            display: 'block'
                        }}>
                            {t("FooterBox20", translations, language)}
                        </Link>
                        {language === 'it' ? (
                            <Box onClick={() => window.open('https://help.crhmoney.com', '_blank')}
                                style={{ cursor: 'pointer', marginBottom: 1, alignSelf: 'flex-start' }}>
                                <Typography className="footer-text">
                                    Help Center
                                </Typography>
                            </Box>
                        ) : (
                            <Box onClick={() => window.open('https://help.crhmoney.com', '_blank')}
                                style={{ cursor: 'pointer', marginBottom: 1, alignSelf: 'flex-start' }}>
                                <Typography className="footer-text">
                                    Help Center
                                </Typography>
                            </Box>
                        )}
                        <Link className="footer-text" to="/contact_us" style={{
                            textDecoration: 'none',
                            color: 'inherit',
                            marginBottom: 1,
                            alignSelf: 'flex-start',
                            display: 'block'
                        }}>
                            {t("FooterBox21", translations, language)}
                        </Link>

                    </Grid>
                </Grid>
                <Box sx={{ mt: { xs: 24, sm: 18, md: 6, lg: 4 } }}>
                    <Typography className="footer-text" sx={{
                        textAlign: 'center',
                        lineHeight: 1.6,
                        padding: { xs: 2, sm: 8, md: 4, lg: 5 },
                    }}>
                        {t("FooterBox23", translations, language)}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}

export default Footer;